import { api } from "../../../services/rpc/RpcProvider";

export const useAutomationFields = (id: string) => {
  const { data: fields } = api.automations.fields.useQuery({ id });

  return { fields };
};
